<script setup lang="ts">
import { logoDark } from '@therobotcompany/robco-frontend-library';
import gettext from '@/i18n/gettext';

const { $gettext } = gettext;
</script>
<template>
  <div class="pa-4 pa-sm-12">
    <v-row class="text-center">
      <v-col cols="12">
        <img
          :src="logoDark"
          alt="RobCo Logo"
          class="my-3"
          contain
          height="200"
        />
      </v-col>
      <v-col class="mb-4">
        <h1 class="display-2 mb-3">
          {{ $gettext('The URL you requested does not exist.') }}
        </h1>
        <h1 class="display-2 mb-3">404</h1>
      </v-col>
    </v-row>
  </div>
</template>
